"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterMetricService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
const _ = require("lodash");
//INTERNAL LIBRARY BITS
const notification_service_1 = require("./notification.service");
const bid_data_filter_service_1 = require("./bid-data-filter.service");
let FilterMetricService = class FilterMetricService {
    constructor(_http, _talk, _bidFilters) {
        this._http = _http;
        this._talk = _talk;
        this._bidFilters = _bidFilters;
        //declarations
        this.filterMetricTypes = [];
        this.allFilterMetricTypes = [];
        //initializations
        this.filterMetricTypeUrl = '/filtermetrictype';
    }
    pull() {
        return this._http.get(this.filterMetricTypeUrl)
            .toPromise()
            .then((response) => this.set(response.json()))
            .catch(this._talk.handle);
    }
    adminPull(params = { filterSource: this._bidFilters.DEFAULT_FILTER_DATA_SOURCE, queryParams: {} }) {
        return this._bidFilters.adminFind(params)
            .then(response => this.setPopulatedFilters(response.json()))
            .catch(this._talk.handle);
    }
    set(metricsTypes) {
        if (metricsTypes && metricsTypes.length)
            this.filterMetricTypes = metricsTypes;
        return this.filterMetricTypes;
    }
    setPopulatedFilters(populatedFilters) {
        if (populatedFilters && populatedFilters.length)
            this.allFilterMetricTypes = populatedFilters;
        return this.allFilterMetricTypes;
    }
    get() {
        if (this.filterMetricTypes && this.filterMetricTypes.length)
            return Promise.resolve(_.cloneDeep(this.filterMetricTypes));
        return this.pull();
    }
    adminGet() {
        if (this.allFilterMetricTypes && this.allFilterMetricTypes.length)
            return Promise.resolve(_.cloneDeep(this.allFilterMetricTypes));
        return this.adminPull();
    }
    buildFiltersTypeSourcesMap(filtersTypes = []) {
        return filtersTypes.reduce((mappedFilters, filterTypeData) => {
            const { dataSource } = filterTypeData, filterType = __rest(filterTypeData, ["dataSource"]);
            if (!mappedFilters.has(dataSource.slug)) {
                mappedFilters.set(dataSource.slug, { dataSource, filterTypes: [filterType] });
            }
            else {
                const currentValues = mappedFilters.get(dataSource.slug);
                currentValues.filterTypes.push(filterType);
                mappedFilters.set(dataSource.slug, currentValues);
            }
            return mappedFilters;
        }, new Map());
    }
};
exports.FilterMetricService = FilterMetricService;
exports.FilterMetricService = FilterMetricService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        notification_service_1.NotificationService,
        bid_data_filter_service_1.BidDataFilterService])
], FilterMetricService);
//# sourceMappingURL=filter-metric.service.js.map